import { useState, useCallback, useMemo } from 'react';
import { NavLink, Link } from 'react-router-dom';
import styles from './Header.module.css';
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../../constants/LANGUAGE";
import logo from '../../Neuro_Design_logo.svg'


const Header = () => {
  const { i18n, t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);


  const navLinkClasses = useMemo(() =>
    "text-black text-base font-light uppercase font-inter leading-5 hover:text-orange-500 transition-colors",
    []
  );


  const onChangeLang = useCallback((e) => {
    const lang_code = e.target.value;
    i18n.changeLanguage(lang_code);
  }, [i18n]);


  const getNavLinkClassName = useCallback(({ isActive }) => {
    return isActive ? `${navLinkClasses} ${styles.activeLink}` : navLinkClasses;
  }, [navLinkClasses]);


  const toggleMobileMenu = useCallback(() => {
    setMobileMenuOpen(prev => !prev);
  }, []);


  const closeMobileMenu = useCallback(() => {
    setMobileMenuOpen(false);
  }, []);


  const navigationLabels = useMemo(() => ({
    main: t("main.main_label"),
    project: t("header_footer.project"),
    service: t("header_footer.service"),

    about: t("header_footer.about"),
    contact: t("header_footer.contact")
  }), [t]);
  return (
    <header className={styles.header}>
      <div className={styles.header__container}>
        <div className={styles.header__container__logo}>
          <Link to="/"><img
            src={logo}
            alt="NeuroDesign Logo"
          /></Link>
        </div>
        <nav className={styles.nav}>
          <NavLink
            to="/projects"
            className={getNavLinkClassName}
          >
            {navigationLabels.project}
          </NavLink>
          <NavLink
            to="/solutions"
            className={getNavLinkClassName}
          >
            {navigationLabels.service}
          </NavLink>

          <NavLink
            to="/about"
            className={getNavLinkClassName}
          >
            {navigationLabels.about}
          </NavLink>
          <NavLink
            to="/contacts"
            className={getNavLinkClassName}
          >
            {navigationLabels.contact}
          </NavLink>

        </nav>

        <a
          href={`https://wa.me/${t("contact.address.phone.telephone").replace(/[^0-9]/g, "")}`}
          className={styles.whatsapp_button}
          target="_blank"
          rel="noopener noreferrer"
        >
          CONTACT US
        </a>

        <div className={styles.burger_menu} onClick={toggleMobileMenu}>
          <div className={styles.burger_line}></div>
          <div className={styles.burger_line}></div>
          <div className={styles.burger_line}></div>
        </div>


        <div className={`${styles.mobile_nav} ${mobileMenuOpen ? styles.open : ''}`}>
          <div className={styles.close_button} onClick={closeMobileMenu}></div>
          <NavLink
            to="/"
            className={getNavLinkClassName}
            onClick={closeMobileMenu}
          >
            {navigationLabels.main}
          </NavLink>
          <NavLink
            to="/about"
            className={getNavLinkClassName}
            onClick={closeMobileMenu}
          >
            {navigationLabels.about}
          </NavLink>
          <NavLink
            to="/solutions"
            className={getNavLinkClassName}
            onClick={closeMobileMenu}
          >
            {navigationLabels.service}
          </NavLink>

          <NavLink
            to="/projects"
            className={getNavLinkClassName}
            onClick={closeMobileMenu}
          >
            {navigationLabels.project}
          </NavLink>


          <NavLink
            to="/contacts"
            className={getNavLinkClassName}
            onClick={closeMobileMenu}
          >
            {navigationLabels.contact}
          </NavLink>

        </div>
      </div>
    </header>
  );
};

export default Header;